import { useEffect, useState } from "react";
import { toast } from "sonner";
import { KeyRound, Copy, Send } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

export function ClientAccess({ contact }) {
  const [account, setAccount] = useState(undefined);
  const [link, setLink] = useState("");

  useEffect(() => {
    api.get("/admin/clients").then(({ data }) => setAccount(data.find((c) => c.contact_id === contact.id) || null)).catch(() => setAccount(null));
  }, [contact.id]);

  const run = async (fn, msg) => {
    try { const { data } = await fn(); if (data.activation_link) setLink(data.activation_link); if (data.id) setAccount(data); toast.success(msg); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const create = () => run(() => api.post("/admin/clients", { contact_id: contact.id }), "Accès créé, email d'activation envoyé");
  const resend = () => run(() => api.post(`/admin/clients/${account.id}/invite`), "Invitation renvoyée");
  const toggle = () => run(() => api.put(`/admin/clients/${account.id}`, { active: !account.active }), account.active ? "Accès désactivé" : "Accès réactivé");

  if (account === undefined) return null;
  return (
    <div className="p-3 rounded-xl border border-[#1E293B] bg-[#0B0F17]" data-testid="client-access-box">
      <div className="flex items-center gap-2 text-xs text-slate-400 uppercase font-mono"><KeyRound className="w-3.5 h-3.5" /> Espace client</div>
      {!account ? (
        <>
          <p className="mt-2 text-xs text-slate-500">{contact.email ? `Un email d'activation sera envoyé à ${contact.email}.` : "Ajoutez un email au contact pour créer son accès."}</p>
          <button onClick={create} disabled={!contact.email} data-testid="client-access-create" className="mt-2 px-3 py-2 rounded-lg bg-[#4CB944] text-white text-xs font-semibold disabled:opacity-40">Créer l'accès Espace client</button>
        </>
      ) : (
        <>
          <div className="mt-2 text-sm text-white" data-testid="client-access-status">{account.email} · {!account.active ? <span className="text-rose-400">Désactivé</span> : account.activated ? <span className="text-emerald-400">Actif</span> : <span className="text-amber-400">En attente d'activation</span>}</div>
          <div className="mt-2 flex flex-wrap gap-2">
            {!account.activated && <button onClick={resend} data-testid="client-access-resend" className="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg bg-[#1E293B] text-slate-200 text-xs"><Send className="w-3 h-3" /> Renvoyer l'invitation</button>}
            <button onClick={toggle} data-testid="client-access-toggle" className="px-3 py-1.5 rounded-lg bg-[#1E293B] text-slate-200 text-xs">{account.active ? "Désactiver" : "Réactiver"}</button>
          </div>
        </>
      )}
      {link && (
        <button onClick={() => { navigator.clipboard.writeText(link); toast.success("Lien copié"); }} data-testid="client-access-copy-link" className="mt-2 w-full inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-[#3B82F6]/15 text-[#60A5FA] text-xs truncate"><Copy className="w-3 h-3 shrink-0" /> Copier le lien d'activation</button>
      )}
    </div>
  );
}
